import axios from "axios"

class Client {
    constructor() {
        this.axios = axios.create({
            baseURL: process.env.VUE_APP_METRIC_URL,
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
    }

    async send(messages) {
        return await this.axios.post('/metric', messages)
    }
}

export default new Client()